import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { Box, Collapse } from '@mui/material'
import { IconButton, Typography } from '@carto/meridian-ds/components'
import { ExpandMoreOutlined, ExpandLessOutlined } from '@mui/icons-material'

function AdvancedOptions({ children }: { children: React.ReactNode }) {
  const [collapsed, setCollapsed] = useState(true)

  return (
    <Box mt={3}>
      <Box
        mt={2}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        onClick={() => setCollapsed(!collapsed)}
      >
        <Typography variant="subtitle2">
          <FormattedMessage id="connections.create.advanced.title" />
        </Typography>
        <IconButton
          icon={collapsed ? <ExpandMoreOutlined /> : <ExpandLessOutlined />}
          aria-label={`${collapsed ? 'Expand' : 'Collapse'} advanced options`}
        />
      </Box>
      <Collapse in={!collapsed}>{children}</Collapse>
    </Box>
  )
}

export default AdvancedOptions
